import { Box, Flex } from 'components/box';
import { Text } from 'components/typography';
import Button from 'components/button';
import dynamic from 'next/dynamic';

const Modal = dynamic(
  () => import('components/_shared/widgets/modal/with-close')
);

const ParallelImportModal = ({
  close,
  isOpen,
}: {
  close: () => void;
  isOpen: boolean;
}) => (
  <Modal
    title="This product is a parallel import."
    close={close}
    isOpen={isOpen}
    size="small"
  >
    <Box mx={[0, null, 5]}>
      <Text fontSize={2} lineHeight={1.5} color="darkGrey">
        Although this product is completely authentic, it has been imported
        without the approval or license of the registered owner of the trademark
        and therefore no guarantee or warranty in respect of such goods will be
        honored or fulfilled by any official or licensed importer of such goods.
        However, any warranty claims will be covered by OneDayOnly or the
        relevant third-party seller, in accordance with our standard
        return/refund policy.
      </Text>
    </Box>

    <Flex mt={4} mb={3} justifyContent="center">
      <Button onClick={close}>Okay</Button>
    </Flex>
  </Modal>
);

export default ParallelImportModal;
